export default __webpack_public_path__ + "static/media/workplace-animals.d3752156.png";